import React from "react";

/**
 * Built-in icons an admin can assign to a topic category. Keys MUST match
 * core.TopicCategory.ICON_CHOICES on the backend (the API rejects others).
 *
 * Every icon is a 24×24 path set. `stroke` icons use the current colour as a
 * 1.8px line; `fill` icons paint the path. `color` overrides the default gold
 * for brand marks (YouTube keeps the rose the video badge already uses).
 */
export const CATEGORY_ICONS = {
  "": {
    label: "Folder",
    stroke: true,
    d: "M3 7a2 2 0 012-2h4l2 2h8a2 2 0 012 2v8a2 2 0 01-2 2H5a2 2 0 01-2-2V7z",
  },
  youtube: {
    label: "YouTube",
    color: "var(--tag-rose)",
    d: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z",
  },
  video: {
    label: "Video",
    stroke: true,
    d: "M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z",
  },
  book: {
    label: "Book",
    stroke: true,
    d: "M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253",
  },
  grammar: {
    label: "Grammar",
    d: "M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2zm1 14.93V15a1 1 0 0 0-2 0v1.93A8 8 0 0 1 4.07 11H6a1 1 0 0 0 0-2H4.07A8 8 0 0 1 11 4.07V6a1 1 0 0 0 2 0V4.07A8 8 0 0 1 19.93 11H18a1 1 0 0 0 0 2h1.93A8 8 0 0 1 13 16.93z",
  },
  chat: {
    label: "Conversation",
    stroke: true,
    d: "M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z",
  },
  listening: {
    label: "Listening",
    stroke: true,
    d: "M3 18v-6a9 9 0 0118 0v6M21 19a2 2 0 01-2 2h-1a2 2 0 01-2-2v-3a2 2 0 012-2h3zM3 19a2 2 0 002 2h1a2 2 0 002-2v-3a2 2 0 00-2-2H3z",
  },
  microphone: {
    label: "Speaking",
    stroke: true,
    d: "M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z",
  },
  pen: {
    label: "Writing",
    stroke: true,
    d: "M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z",
  },
  quran: {
    label: "Quran",
    stroke: true,
    d: "M12 3l2 3h4l1 4-2 2v6a1 1 0 01-1 1H8a1 1 0 01-1-1v-6l-2-2 1-4h4l2-3zM9 19v2M15 19v2M12 12v3",
  },
  star: {
    label: "Star",
    d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z",
  },
  graduation: {
    label: "Graduation",
    stroke: true,
    d: "M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422A12.083 12.083 0 0118 14.5c0 1.5-.5 3-1.5 4.5L12 21l-4.5-2C6.5 17.5 6 16 6 14.5c0-.995.058-1.968.16-2.922L12 14z",
  },
  sparkles: {
    label: "Sparkles",
    stroke: true,
    d: "M5 3v4M3 5h4M6 17v4M4 19h4M13 3l2.5 6.5L22 12l-6.5 2.5L13 21l-2.5-6.5L4 12l6.5-2.5L13 3z",
  },
};

/** Ordered keys for pickers (folder/default first). */
export const CATEGORY_ICON_KEYS = Object.keys(CATEGORY_ICONS);

/** Render a category's icon; unknown/legacy keys fall back to the folder. */
export function CategoryIcon({ icon, className = "w-4 h-4", style }) {
  const def = CATEGORY_ICONS[icon] || CATEGORY_ICONS[""];
  const color = def.color || "var(--gold)";
  return def.stroke ? (
    <svg className={className} style={{ color, ...style }} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8} aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" d={def.d} />
    </svg>
  ) : (
    <svg className={className} style={{ color, ...style }} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d={def.d} />
    </svg>
  );
}
